class PollOnDirective {
  constructor(globalEventBus) {
    this.eventBus = globalEventBus;
  }

  mounted(targetElement, binding) {
    const taskIdentifier = this.resolveTaskId(binding);
    if (!taskIdentifier) return;

    const pollingConfig = binding.value || {};
    const pollingInterval = pollingConfig.every || null;

    this.startPolling(taskIdentifier, pollingInterval);

    if (pollingInterval) {
      const intervalDuration = this.parseInterval(pollingInterval);
      const pollingTimer = this.createTimer(
        taskIdentifier,
        pollingInterval,
        intervalDuration
      );
      targetElement._pollTimer = pollingTimer;
    }
  }

  unmounted(targetElement) {
    if (targetElement._pollTimer) {
      clearInterval(targetElement._pollTimer);
      delete targetElement._pollTimer;
    }
  }

  resolveTaskId(binding) {
    if (!binding?.arg) return null;

    const base = binding.arg;
    const modifier = Object.keys(binding.modifiers)?.[0];
    return modifier ? `${base}.${modifier}` : base;
  }

  startPolling(taskIdentifier, pollingInterval) {
    this.eventBus.emit('polling.start', {
      taskId: taskIdentifier,
      every: pollingInterval
    });
  }

  createTimer(taskIdentifier, pollingInterval, milliseconds) {
    return setInterval(() => {
      this.startPolling(taskIdentifier, pollingInterval);
    }, milliseconds);
  }

  parseInterval(rawValue) {
    const match = rawValue.toString().match(/^(\d+)(s|m)?$/);
    if (!match) return 30000;

    const value = parseInt(match[1], 10);
    return match[2] === 'm' ? value * 60000 : value * 1000;
  }
}

function createPollOnDirective(eventBus) {
  return new PollOnDirective(eventBus);
}

export { PollOnDirective, createPollOnDirective };
